import PackstationViewController from './PackstationViewController';

export default PackstationViewController;
